import { AccuracyType } from 'api/query/shared/accuracy-type.enum';
import { useUser } from 'providers/user/use-user';
import React from 'react';
import { ASBVCellProps } from './asbv-cell-props';
import './asbv-cell.scss';

/**
 * The content of a TableCell displaying the ASBV value and accuracy.
 * @param props
 */
export const ASBVCell: React.FC<ASBVCellProps> = (props) => {
  const {
    asbv,
  } = props;

  const { isAdmin } = useUser();

  return (
    <div className={`sg-asbv-cell ${isAdmin && asbv.accuracyType !== AccuracyType.Linked && asbv.accuracy !== '' ? 'sg-asbv-cell--red' : ''}`}>
      <div className="data__value">{asbv.value}</div>
      <div className="data__accuracy">
        {asbv.accuracy !== '' && (<span>ACC. </span>)}
        {asbv.accuracy}
      </div>
    </div>
  );
};
